export const formatURL = (tmplUrl, params = {}, escapingFunction = encodeURIComponent) => Object
    .entries(params)
    .reduce((acc, [key, value]) => acc
        .split(`[${key}]`)
        .join(escapingFunction(value)), tmplUrl);
